import { exists } from '@/api'

export interface BatchSchoolUserListCondition {
  gradeCode: string
  classCode: string
  order: string
}

export function BatchSchoolUserListConditionFromJSON(
  json: any
): BatchSchoolUserListCondition {
  const _json = JSON.parse(json)

  return {
    gradeCode: exists(_json, 'grade_code') ? _json.grade_code : '',
    classCode: exists(_json, 'class_code') ? _json.class_code : '',
    order: exists(_json, 'order') ? _json.order : '1'
  }
}
